import { hookstate } from '@hookstate/core'

const globalAnalyticStore = hookstate({
});

export default globalAnalyticStore;